import { SerializableSeries } from '@/optimizer/types';
import { Optimal } from '@analytical-alley/opt-wasm/optimizer/optimizer.interface';

export const formatOptimal = (
    optimal: Optimal,
    refinedSpends?: SerializableSeries,
) => {
    const optimalVariables: Record<
        string,
        {
            maxSpend: number;
            minSpend: number;
            optimalSpend: number;
            kpi: number;
        }
    > = {};

    if (
        optimal.mediums.length !== optimal.spends.length ||
        optimal.mediums.length !== optimal.kpis.length
    ) {
        // eslint-disable-next-line no-console
        console.error(optimal);
        throw new Error(
            'Optimal data is not valid. Mediums length is not equal to maximum, minimum, spend or kpi',
        );
    }
    const minimumSpends = optimal.minimumSpends;
    const maximumSpends = optimal.maximumSpends;

    const refinedSpendMap: Record<string, number> = {};
    if (refinedSpends) {
        refinedSpends.index.forEach((medium, idx) => {
            refinedSpendMap[medium as string] = Math.round(
                refinedSpends.values[idx] as number,
            );
        });
    }

    optimal.mediums.forEach((medium, index) => {
        const maxSpend = maximumSpends[medium]!;
        const minSpend = minimumSpends[medium]!;
        const optimalSpend =
            refinedSpendMap[medium] || Math.round(optimal.spends[index]!);
        const kpi = Math.round(optimal.kpis[index]!);

        optimalVariables[medium] = {
            maxSpend,
            minSpend,
            optimalSpend,
            kpi,
        };
    });

    const mediaKpi =
        optimal.totalKpi != null
            ? optimal.kpis.reduce((sum, value) => sum + (value || 0), 0)
            : optimal.currentKpi;

    const result = {
        mediaKpi,
        totalKpi: optimal.totalKpi ?? optimal.currentKpi,
        optimalVariables,
    };

    return result;
};
